import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { EventMantenedorCategoriaService } from 'src/app/services/event-mantenedor-categoria.service';
import { CategoryService } from 'src/app/services/category.service';
import { EnfoqueService } from 'src/app/services/enfoque.service';
import { EventMantenedorEnfoqueService } from 'src/app/services/event-mantenedor-enfoque.service';
import { EventMantenedorRelatorService } from 'src/app/services/event-mantenedor-relator.service';
import { RelatorService } from 'src/app/services/relator.service';
import { EjecutorService } from 'src/app/services/ejecutor.service';
@Component({
  selector: 'app-table-relator',
  templateUrl: './table-relator.component.html',
  styleUrls: ['./table-relator.component.scss']
})
export class TableRelatorComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElementRelator: DataTableDirective;
  dtTriggerRelator: Subject<any> = new Subject();
  loadingRelator = false;
  searchT: string = "";
  pageActualRelator = 1
  relatorMantenedor: any;
  relator: any;
  relatorFilter: any;
  relatorSelected: any;
  relatorIdSelected: number;
  creationMode: string;
  confirmationModalTittle: string;
  confirmationModalMessage: string;
  confirmationModalHasComment = false;
  allEjecutores: any;
  relatorEjecutores: any;
  confirmationModalHasOptions = false;
  confirmationModalisCommentObligatory = false;
  confirmationModalAccept: any;
  confirmationModalOptionLabel: string;
  confirmationModalOptions: { label: string, value: any }[];
  inputMessageModal:string="";
  initialArrayRelator:any=[];
  mensajeError:string;
  constructor(private relatorService: RelatorService,
    private modalService: NgbModal,
    private ejecutorService: EjecutorService,
    private eventMantenedorRelatorService: EventMantenedorRelatorService
  ) { }

  ngOnInit() {
    this.refreshRelator();

    if (this.eventMantenedorRelatorService.subsVar == undefined) {
      this.eventMantenedorRelatorService.subsVar = this.eventMantenedorRelatorService.
        invokeFirstComponentFunction.subscribe(() => {
          this.refreshRelator();
        });
    }
  }
  changeSearch(e) {
    let valor = e.target.value
    console.log('Filtrando valores')
    console.log(e.target.value)
    console.log(valor.length)
    console.log(this.initialArrayRelator)
    if (valor.length > 0) {
      this.pageActualRelator = 1;
      let word = valor.toLowerCase();
      this.relatorMantenedor = this.initialArrayRelator.filter((item) => {
        let str = item.relator.relatorDescription + ' ' + item.ejecutores[0].ejecutorDescription
        str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return str.toLowerCase().search(word) > -1
      }
      )
      console.log('Registros encontrados')
      console.log(this.relatorMantenedor.length)
    } else {
      this.relatorMantenedor = this.initialArrayRelator;
    }
  }
  ngAfterViewInit(): void {
    this.dtTriggerRelator.next();
  }

  ngOnDestroy(): void {
    this.dtTriggerRelator.unsubscribe();
  }

  refreshRelator() {
    this.loadingRelator = true;
    Promise.all([
      this.getRelatorMantenedor()
    ])
      .then(results => {
        this.relatorMantenedor = results[0];
        this.relatorFilter = results[0];
        this.initialArrayRelator = results[0]
        this.rerenderRelator();
      })
      .catch(error => {
        this.loadingRelator = false;
        console.error(error);
      });
  }

  refreshRelatorCreateOrUpdate(event):void{
    this.inputMessageModal = event;
    this.refreshRelator();
  }

  getRelatorMantenedor(): any {
    this.loadingRelator = true;
    return new Promise((resolve, reject) => {
      this.relatorService.getAllCategorias()
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  rerenderRelator(): void {
    this.loadingRelator = false;
    this.inputMessageModal = "";
    this.dtElementRelator.dtInstance.then((dtInstanceRelator: DataTables.Api) => {
      dtInstanceRelator.destroy();
      this.dtTriggerRelator.next();
    });
  }
  onCreateRelator(modal: any, mode: string, ejecutores: any) {
    const request: JSON = {
      relatorId: ejecutores.relator.relatorId,
      descripcion: ejecutores.relator.relatorDescription,
      estado: 1
    } as unknown as JSON;
    this.relatorSelected = request;
    const modalOptions: NgbModalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' };
    this.creationMode = mode;
    Promise.all([
      this.getAllEjecutores()
    ])
      .then(results => {
        this.allEjecutores = results[0];
        this.relatorEjecutores = ejecutores.ejecutores;
        this.modalService.open(modal, modalOptions);
      })
      .catch(error => console.error(error));
  }

  getLabelEjecutores(zonas: any): string {
    if (zonas.length > 0) {
      let textoZona = '';
      zonas.forEach(element => {
        textoZona += element.ejecutorDescription + ', ';
      });
      const textoZonaLimpio = textoZona.substring(0, textoZona.length - 2);
      return textoZonaLimpio;
    } else {
      return '-';
    }
  }
  getAllEjecutores(): any {
    return new Promise((resolve, reject) => {
      this.ejecutorService.getAllCategorias()
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  openDeleteModalRelator(modal: any, relator: any): void {
    const request: JSON = {
      newRelator:
      {
        relatorId: relator.relatorId,
        descripcion: relator.relatorDescription,
        estado: 1,
        ejecutores: []
      }
    } as unknown as JSON;
    this.relatorSelected = request;
    this.relator = relator;
    this.confirmationModalHasComment = false;
    this.confirmationModalHasOptions = false;
    this.confirmationModalisCommentObligatory = false;
    this.relatorIdSelected = relator.relatorId;
    this.confirmationModalTittle = 'Eliminar Relator';
    this.confirmationModalMessage = `¿Seguro que desea eliminar el relator "${relator.relatorDescription}"?`;
    this.confirmationModalAccept = this.onDeleteZona;
    this.openModal(modal);
  }
  openModal(modal: any, options: any = {}): void {
    const modalOptions = { ariaLabelledBy: 'modal-basic-title', centered: true, ...options };
    this.modalService.open(modal, modalOptions);
  }
  onDeleteZona(): void {
    this.relatorService.delete(this.relatorSelected, this.relatorIdSelected)
      .then(response => {
        if(response != 'OK'){
          this.mensajeError = response;
          $("#divMensajeError").css({"display":"block"});
          setTimeout(this.ocultarMensaje, 10000);
        }
        this.refreshRelator();
      })
      .catch(error => {
        console.error(error);
        this.mensajeError = error.error;
        $("#divMensajeError").css({"display":"block"});
        setTimeout(this.ocultarMensaje, 10000);
      });
  }

  ocultarMensaje() : void {
    $("#divMensajeError").css({"display":"none"});
  }
}
